var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 42,
    fill: "none",
    viewBox: "0 0 44 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 41.36,
    fill: "#F2F7FC",
    rx: 8,
    transform: "matrix(-1 0 0 1 44 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.36,
    fill: "#F2F7FC",
    rx: 8.269,
    transform: "matrix(-1 0 0 1 34 10)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9C1B",
    d: "M12.97 16.65 22 11l9.03 5.65c.58.35.97.98.97 1.71v10c0 1.1-.9 2-2 2H14c-1.1 0-2-.9-2-2v-10c0-.73.39-1.36.97-1.71ZM14 28.36h16v-8l-8 5-8-5v8Zm8-5 8-5-8-5-8 5 8 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.0914cc30ec2ef2a96e26fc0c1aae7459.svg";
export { ForwardRef as ReactComponent };